import Modal from 'react-native-modal';
import {
  Image, StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import Style from '../../constants/Style';
import Colors from '../../constants/Colors';
import PeopleLogo from './PeopleLogo';
import isMobile from '../IsMobile';
import SimplePDFViewer from '../SimplePDFViewer';

interface WelcomeModalProps {
  isVisible: boolean;
  onPress: Dispatch<SetStateAction<boolean>>;
}

export default function WelcomeModal({
  isVisible, onPress,
}: WelcomeModalProps) {
  const defaultLogoUri: string = 'https://s3.eu-west-1.amazonaws.com/insights.hereworks.tech/clientLogos/hereworks-logo.png';

  const [clientLogo, setClientLogo] = useState<string>(defaultLogoUri);
  const {
    firstName, lastName, acceptedTerms, isAdmin,
  } = useSelector((state:
    { user: { firstName, lastName, acceptedTerms, isAdmin } }) => state.user);

  const hasFullName: boolean = firstName?.trim().length > 0 && lastName?.trim().length > 0;
  const navigation = useNavigation();

  useEffect(() => {
    AsyncStorage.getItem('clientLogo').then((logo: string) => {
      if (logo?.length) setClientLogo(logo);
    });
  }, []);

  return <Modal
    {...{ isVisible }}
    animationIn={isMobile ? 'slideInUp' : 'fadeIn'}
    animationOut={isMobile ? 'slideOutDown' : 'fadeOut'}
    onBackButtonPress={() => onPress(false)}
    style={Style.modal}
  >
    {(isAdmin && !acceptedTerms) ? <View style={styles.termsContainer}>
      <SimplePDFViewer />
    </View>
      : <View style={styles.container}>
        {!isMobile && <Image
          source={{
            uri: clientLogo,
          }}
          style={styles.icon}
          resizeMode={'contain'}
        />}
        <View style={[styles.content, Style.boxShadow]}>
          <PeopleLogo />
          <Text style={styles.title}>{hasFullName ? `Welcome ${firstName}` : 'Welcome to Hereworks Insights!'}</Text>
          <Text style={styles.subTitle}>
            {hasFullName ? 'Thank you for choosing to be a part of our system. Your presence enriches our community, and we can\'t wait to witness your contributions.'
              : 'To personalize your experience and ensure we address you correctly, could you please enter your name in the profile page '}
          </Text>
          <TouchableOpacity
            onPress={() => {
              onPress(false);
              if (!hasFullName) {
                if (isMobile) navigation.navigate('Menu' as any);
                else navigation.navigate('Profile' as any);
              }
            }}
            style={styles.button}>
            <Text style={styles.buttonText}>{firstName ? 'Get started' : 'Enter Name'}</Text>
          </TouchableOpacity>
        </View>
      </View>}
  </Modal>;
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: isMobile ? 'transparent' : Colors.light.hereworksBackground,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  termsContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 200,
    height: 90,
    margin: 40,
    position: 'absolute',
    top: 0,
    left: 0,
  },
  title: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 28,
    lineHeight: 42,
    marginVertical: 12,
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
  },
  subTitle: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 16,
    lineHeight: 24,
    color: Colors.light.hereworksBlack400,
    textAlign: 'center',
  },
  content: {
    padding: isMobile ? 24 : 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    maxWidth: isMobile ? '90%' : '44%',
    borderRadius: 10,
    overflow: 'hidden',
  },
  button: {
    backgroundColor: Colors.light.hereworksBlue500,
    borderRadius: 4,
    paddingVertical: 8,
    paddingHorizontal: 24,
    marginTop: 24,
  },
  buttonText: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 16,
    lineHeight: 24,
    color: '#fff',
  },
});
